var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentpending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.808,
    height: 109.808,
    viewBox: "0 0 109.808 109.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8bb611;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-635.877 -375.437)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M74.625,0H70.254a1.839,1.839,0,0,0-1.8,1.458,29.968,29.968,0,0,1-29.3,23.626A29.964,29.964,0,0,1,11.827,7.448l19.331.46a1.835,1.835,0,0,0,1.879-1.835V1.835A1.836,1.836,0,0,0,31.2,0H1.835A1.836,1.836,0,0,0,0,1.835V31.2a1.836,1.836,0,0,0,1.835,1.835H6.074a1.835,1.835,0,0,0,1.835-1.879L7.55,16.081A37.891,37.891,0,0,0,39.156,33.037,37.943,37.943,0,0,0,76.43,2.168,1.834,1.834,0,0,0,74.625,0Z",
    transform: "translate(668.257 461.884) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M74.625,0H70.254a1.839,1.839,0,0,0-1.8,1.458,29.968,29.968,0,0,1-29.3,23.626A29.964,29.964,0,0,1,11.827,7.448l19.331.46a1.835,1.835,0,0,0,1.879-1.835V1.835A1.836,1.836,0,0,0,31.2,0H1.835A1.836,1.836,0,0,0,0,1.835V31.2a1.836,1.836,0,0,0,1.835,1.835H6.074a1.835,1.835,0,0,0,1.835-1.879L7.55,16.081A37.891,37.891,0,0,0,39.156,33.037,37.943,37.943,0,0,0,76.43,2.168,1.834,1.834,0,0,0,74.625,0Z",
    transform: "translate(713.305 398.798) rotate(135)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentpending);
export default __webpack_public_path__ + "static/media/Payment pending.653b8b67bc6d78960f289f2cc2c1bcb3.svg";
export { ForwardRef as ReactComponent };